'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-1887e1af.js');
var styled = require('styled-components');

var muiInputWidthStyles = styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 288px;\n"], ["\n  width: 288px;\n"])));
var muiInputHeightStyles = styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  .MuiInputBase-root {\n    border-radius: 7px;\n    height: 48px;\n  }\n"], ["\n  .MuiInputBase-root {\n    border-radius: 7px;\n    height: 48px;\n  }\n"])));
var muiInputPaddingStyles = styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  .MuiOutlinedInput-root {\n    input.MuiAutocomplete-input {\n      padding: 0 4px 0 4px;\n    }\n  }\n"], ["\n  .MuiOutlinedInput-root {\n    input.MuiAutocomplete-input {\n      padding: 0 4px 0 4px;\n    }\n  }\n"])));
var muiInputBorderStyles = styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  .MuiOutlinedInput-root {\n    &:hover {\n      fieldset {\n        border-color: ", ";\n      }\n    }\n    fieldset {\n      border-color: ", ";\n    }\n    &.Mui-focused fieldset {\n      border-color: ", ";\n    }\n  }\n"], ["\n  .MuiOutlinedInput-root {\n    &:hover {\n      fieldset {\n        border-color: ", ";\n      }\n    }\n    fieldset {\n      border-color: ", ";\n    }\n    &.Mui-focused fieldset {\n      border-color: ", ";\n    }\n  }\n"])), function (_a) {
    var secondary = _a.theme.colors.input.secondary;
    return secondary;
}, function (_a) {
    var primary = _a.theme.colors.input.primary;
    return primary;
}, function (_a) {
    var interactive = _a.theme.colors.input.interactive;
    return interactive;
});
var muiInputErrorStyles = styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  .MuiFormHelperText-root.Mui-error {\n    color: ", ";\n  }\n  .Mui-error {\n    .MuiOutlinedInput-notchedOutline {\n      border-color: ", ";\n    }\n  }\n  label.Mui-error {\n    color: ", ";\n  }\n  .MuiOutlinedInput-root {\n    &.Mui-error fieldset {\n      border-color: ", ";\n    }\n  }\n"], ["\n  .MuiFormHelperText-root.Mui-error {\n    color: ", ";\n  }\n  .Mui-error {\n    .MuiOutlinedInput-notchedOutline {\n      border-color: ", ";\n    }\n  }\n  label.Mui-error {\n    color: ", ";\n  }\n  .MuiOutlinedInput-root {\n    &.Mui-error fieldset {\n      border-color: ", ";\n    }\n  }\n"])), function (_a) {
    var negative = _a.theme.colors.text.negative;
    return negative;
}, function (_a) {
    var negative = _a.theme.colors.text.negative;
    return negative;
}, function (_a) {
    var negative = _a.theme.colors.text.negative;
    return negative;
}, function (_a) {
    var negative = _a.theme.colors.input.negative;
    return negative;
});
var muiInputTextStyles = styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  .MuiOutlinedInput-input {\n    color: ", ";\n  }\n\n  .MuiInputLabel-formControl {\n    color: ", ";\n  }\n\n  label {\n    line-height: 18px;\n    color: ", ";\n  }\n\n  label.Mui-focused {\n    color: ", ";\n  }\n\n  .MuiButtonBase-root.MuiIconButton-root {\n    color: ", ";\n  }\n"], ["\n  .MuiOutlinedInput-input {\n    color: ", ";\n  }\n\n  .MuiInputLabel-formControl {\n    color: ", ";\n  }\n\n  label {\n    line-height: 18px;\n    color: ", ";\n  }\n\n  label.Mui-focused {\n    color: ", ";\n  }\n\n  .MuiButtonBase-root.MuiIconButton-root {\n    color: ", ";\n  }\n"])), function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, function (_a) {
    var interactive = _a.theme.colors.text.interactive;
    return interactive;
}, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
});
var muiInputDisabledStyles = styled.css(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  .Mui-disabled.MuiInputLabel-shrink {\n    color: ", ";\n  }\n\n  .Mui-disabled.MuiInputLabel-formControl {\n    color: ", ";\n  }\n\n  .Mui-disabled.MuiOutlinedInput-root {\n    background-color: ", ";\n  }\n  .Mui-disabled {\n    .MuiOutlinedInput-notchedOutline {\n      border-color: ", ";\n    }\n  }\n"], ["\n  .Mui-disabled.MuiInputLabel-shrink {\n    color: ", ";\n  }\n\n  .Mui-disabled.MuiInputLabel-formControl {\n    color: ", ";\n  }\n\n  .Mui-disabled.MuiOutlinedInput-root {\n    background-color: ", ";\n  }\n  .Mui-disabled {\n    .MuiOutlinedInput-notchedOutline {\n      border-color: ", ";\n    }\n  }\n"])), function (_a) {
    var disabled = _a.theme.colors.text.disabled;
    return disabled;
}, function (_a) {
    var disabled = _a.theme.colors.text.disabled;
    return disabled;
}, function (_a) {
    var tertiary = _a.theme.colors.background.tertiary;
    return tertiary;
}, function (_a) {
    var disabled = _a.theme.colors.text.disabled;
    return disabled;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports.muiInputBorderStyles = muiInputBorderStyles;
exports.muiInputDisabledStyles = muiInputDisabledStyles;
exports.muiInputErrorStyles = muiInputErrorStyles;
exports.muiInputHeightStyles = muiInputHeightStyles;
exports.muiInputPaddingStyles = muiInputPaddingStyles;
exports.muiInputTextStyles = muiInputTextStyles;
exports.muiInputWidthStyles = muiInputWidthStyles;
